export function sleep(ms: number) {
    return new Promise<void>((resolve) => setTimeout(() => resolve(), ms))
}

export async function tick() {
    await sleep(0)
}
